import { Button, Checkbox, DataSource, HorizontalSpacer, Image, Label, Layout, Panel, Tab, Table, Tabset, Textbox} from "@mcleod/components";

export abstract class AutogenLayoutUserSettings extends Layout {
	buttonSave: Button;
	checkboxAllowNewDevices: Checkbox;
	checkboxSelTextOnFocus: Checkbox;
	horizontalspacer2: HorizontalSpacer;
	image11: Image;
	labelDevices: Label;
	labelSample: Label;
	labelSampleDateTime: Label;
	labelUserSettings: Label;
	panel2: Panel;
	panel3: Panel;
	panel4: Panel;
	sourceCurrentUserPowerbroker: DataSource;
	sourceSettings: DataSource;
	sourceUserRecognizedDevice: DataSource;
	sourceUsers: DataSource;
	tabGeneral: Tab;
	tabLogin: Tab;
	tabOperations: Tab;
	tableUserDevices: Table;
	tabset1: Tabset;
	textDateFormat: Textbox;
	textTheme: Textbox;
	textTimeFormat: Textbox;
	textboxBpProfile: Textbox;
	textboxDefaultDispatchLayout: Textbox;
	textboxTmProfile: Textbox;
}
